<template>
    <div id="newintervention">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="goToPlanningPage" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="goToNewGroupPage" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="goToAllUserPage" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div class="filAriane">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <div v-if="!isPlanning">
            <h1>
                <button v-on:click="backbtn()" class="btnBack">
                    <font-awesome-icon icon="arrow-alt-circle-left" />
                </button>
                {{inquiry.name}} - Nouvelle intervention
            </h1>            
            <div v-for="indexFor2 in inChargeNb " :key="indexFor2">
                <div id="blabla" class="containerSingle">
                    <div class="textline">
                        <b class="textLen">Date de début :</b>
                        <datepicker @selected="changeHandler(indexFor2-1)" input-class="inputDate" class="wrapperDate" :language="fr" v-model="pick[indexFor2-1].start.date"></datepicker>
                    </div>
                    <div class="textline">
                        <b class="textLen">Heure de début :</b>
                        <vue-timepicker @change="changeHandler(indexFor2-1)" class="wrapperDate" :minute-interval="5" v-model="pick[indexFor2-1].start.hour" hide-clear-button></vue-timepicker>
                    </div>
                    <div class="textline">
                        <b class="textLen">Date de fin :</b>
                        <datepicker @selected="changeHandler(indexFor2-1)" input-class="inputDate" class="wrapperDate" :language="fr" v-model="pick[indexFor2-1].end.date"></datepicker>
                    </div>
                    <div class="textline">
                        <b class="textLen">Heure de fin :</b>
                        <vue-timepicker @change="changeHandler(indexFor2-1)" class="wrapperDate" :minute-interval="5" v-model="pick[indexFor2-1].end.hour" hide-clear-button></vue-timepicker>
                    </div>
                    
                    <b class="textLen">Utilisateur <i style="color:red;">*</i>&nbsp;&nbsp;:</b>
                    <select class="inputTxt select" v-model="intervention.planning[indexFor2-1].user">
                        <option class="inputTxt" :value="{idWeweb:''}" selected>
                            Sélectionner
                        </option>
                        <option class="inputTxt" v-for="(itemIncharge, indexIncharge) in inchargeToSelect" :key="indexIncharge" :value="{idWeweb:itemIncharge.idWeweb}">
                            {{itemIncharge.address.firstName +" "+itemIncharge.address.lastName}}
                        </option>
                    </select>
                    <div v-if="indexFor2 === inChargeNb" class="blockBtn">
                        <b class="textLen"></b>
                        <button class="btnNewBtn" v-on:click="inChargeNbInc()"><font-awesome-icon icon="plus" />
                        </button>
                        Ajouter  
                    </div>  
                </div>
            </div>
            <div class="containerSingle">
                <div class="textline">
                    <b class="textLen">Type <i style="color:red;">*</i>&nbsp;&nbsp;:</b>
                    <select class="inputTxt select" v-model="intervention.type">
                        <option class="inputTxt" :value="''" selected>
                            Sélectionner
                        </option>
                        <option class="inputTxt" :value="'Intervention standard'">
                            Intervention standard
                        </option>
                        <option class="inputTxt" :value="'Recherche fuite'">
                            Recherche fuite
                        </option>
                        <option class="inputTxt" :value="'Entretien'">
                            Entretien
                        </option>
                        <option class="inputTxt" :value="'Service après-vente'">
                            Service après-vente
                        </option>
                    </select>
                </div>
                <div class="textline">
                    <b class="textLen">En déplacement : </b>
                    <input class="radioBtn" type="radio" name="isJointOwnershipRadio" :value="true" v-model="intervention.isRemote" style="width: 15px !important;">
                    <span>Oui</span>
                    <input class="radioBtn" type="radio" name="isJointOwnershipRadio" :value="false" v-model="intervention.isRemote" checked style="width: 15px !important;">
                    <span>Non</span><br>
                </div>
                <div class="textline">
                    <b class="textLen high">Bloc notes :</b>
                    <textarea rows="8" class="inputTxt area" type="text"  v-model="intervention.note" ></textarea>
                </div>
                <div class="textline">
                    <div v-for="indexFor4 in emailRDVNb " :key="indexFor4">
                        <b v-if="indexFor4===1" class="textLen">Email de confirmation :</b>
                        <b v-else class="textLen"></b>
                        <select id="allowedUserSelect" class="inputTxt select" v-model="intervention.emailRDV[indexFor4 - 1]">
                            <option class="inputTxt" :value="undefined" selected>
                                Sélectionner
                            </option>
                            <option class="inputTxt" v-for="(itemIncharge, indexIncharge) in UserDataForEmail" :key="indexIncharge" :value="itemIncharge.emailAddress">
                                {{itemIncharge.type +" - "+itemIncharge.firstName +" "+itemIncharge.lastName +" - "+ itemIncharge.emailAddress}}
                            </option>
                        </select>
                    </div>
                    <div class="blockBtn">
                        <b class="textLen"></b>
                        <button class="btnNewBtn" v-on:click="emailRDVNbInc()"><font-awesome-icon icon="plus" />
                        </button>
                        Ajouter  
                    </div>  
                </div>
                <div class="textline">
                    <div v-for="indexFor3 in emailReminderNb " :key="indexFor3">
                        <b v-if="indexFor3===1" class="textLen">Email de rappel :</b>
                        <b v-else class="textLen"></b>
                        <select id="allowedUserSelect" class="inputTxt select" v-model="intervention.emailReminder[indexFor3 - 1]">
                            <option class="inputTxt" :value="undefined" selected>
                                Sélectionner
                            </option>
                            <option class="inputTxt" v-for="(itemIncharge, indexIncharge) in UserDataForEmail" :key="indexIncharge" :value="itemIncharge.emailAddress">
                                {{itemIncharge.type +" - "+itemIncharge.firstName +" "+itemIncharge.lastName +" - "+ itemIncharge.emailAddress}}
                            </option>
                        </select>
                    </div>
                    <div class="blockBtn">
                        <b class="textLen"></b>
                        <button class="btnNewBtn" v-on:click="emailReminderNbInc()"><font-awesome-icon icon="plus" />
                        </button>
                        Ajouter  
                    </div>  
                </div>
            </div>
            <div class="btnContainer">
                <button v-on:click="uploadIntervention()" class="btn">Valider</button>
            </div>

            <modal height="250px" width="400px" name="validationModal">
                <div class="modalDiv">  
                    <div class="txtDiv">
                        <img class="modalTxt" :src="imgValidation"/>
                    </div>  
                    <div class="txtDiv">
                        <span class="modalTxt">{{validationPhrase}}</span>
                    </div>    
                    <button class="docBtn3" type="button" v-on:click="okButton()">OK</button>   
                </div>    
            </modal>
        </div>
        <div v-else>
            <h1>
                <button v-on:click="backbtn()" class="btnBack">
                    <font-awesome-icon icon="arrow-alt-circle-left" />
                </button>
                {{planningTitle}}
            </h1>
            <div id='calendar'>
                <FullCalendar   class="calendar"
                                ref="fullcalendar"
                                @dateClick="handleDateClick"
                                @eventClick="eventClick"
                                @select="pickRDV"
                                :themeSystem='themeCal'
                                schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                                timeZone="Europe/Paris" 
                                defaultView="resourceTimelineDay" 
                                resourceLabelText="Techniciens"
                                locale='fr'
                                minTime='05:00:00'
                                maxTime='20:00:00'
                                resourceAreaWidth='135px'
                                :weekends="false"
                                :slotDuration='slotDuration()'
                                :buttonText="btnTxt"
                                :selectable="calSelect"
                                :nowIndicator="calNow"
                                :editable="calEdit"
                                :plugins="calendarPlugins"
                                :header="calHeader"
                                :resources="calResources"
                                :events="calEvents"
                                :datesRender="datesRender"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Datepicker from 'vuejs-datepicker';
    import {fr} from 'vuejs-datepicker/dist/locale'
    import VueTimepicker from 'vue2-timepicker'
    import FullCalendar from '@fullcalendar/vue'
    import interactionPlugin from '@fullcalendar/interaction'
    import resourceCommonPlugin from '@fullcalendar/resource-common'
    import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
    import timegridPluginRes from '@fullcalendar/resource-timegrid'
    import daygridPluginRes from '@fullcalendar/resource-daygrid'
    import timegridPlugin from '@fullcalendar/timegrid'
    import daygridPlugin from '@fullcalendar/daygrid'
    import bootstrapPlugin from '@fullcalendar/bootstrap'
    import timelinePlugin from '@fullcalendar/timeline'
    import listPlugin from '@fullcalendar/list'
    import luxonPlugin from '@fullcalendar/luxon'
    import momentPlugin from '@fullcalendar/moment'
    import momentTZPlugin from '@fullcalendar/moment-timezone'

    import '@fullcalendar/core/main.css';
    import '@fullcalendar/resource-timeline/main.css';
    import '@fullcalendar/timeline/main.css';
    import '@fullcalendar/list/main.css';

    export default {
        name: 'Newintervention',
        components: {
            Datepicker,
            VueTimepicker,
            FullCalendar
        },
        data() {
            return {
                Name:"ADPR",
                inChargeNb:1,
                emailReminderNb:1,
                emailRDVNb:1,
                navWidth:0,
                navMenuVisible:false,
                filAriane: "",
                isPlanning: true,
                complement: "",
                planningTitle:"Sélectionnez l'horaire de l'intervenant principal :",
                validationPhrase: "La nouvelle intervention a été correctement enregistré",
                imgValidation: "/assets/right.png",
                fr:fr,
                UserDataForEmail:[],
                plannings: [],
                inchargeToSelect:   [],
                inchargeToSelectAll:   [],
                calRatio:1.5,
                calEvents:[],
                calResources:[],
                themeCal:'Materia',
                calEdit:false,
                calSelect:true,
                calNow:true,
                activeStart: new Date()/1000 | 0,
                activeEnd: new Date()/1000 | 0,
                addressStr: "",
                calHeader: {
                          left: 'prev, next, resourceTimelineDay, resourceTimelineWeek, resourceTimelineMonth',
                          center: 'title',
                          right: "today"
                        },
                btnTxt:{
                        today:    "Revenir à Aujourd'hui",
                        month:    'mois',
                        week:     'semaine',
                        day:      'jour',
                        list:     'liste'
                },
                color:["Gold","Orange","Lime","DodgerBlue","Indigo","Red","Magenta","RosyBrown","Pink","DarkKhaki","Cyan","DarkGoldenRod","Purple","Yellow","RebeccaPurple","Salmon","Green","Teal","OrangeRed","Blue","SaddleBrown","Maroon","Tan","Peru","Olive","Gray","Black"],
                calendarPlugins: [
                                    interactionPlugin,
                                    resourceTimelinePlugin,
                                    timegridPlugin,
                                    daygridPlugin,
                                    timegridPluginRes, 
                                    daygridPluginRes, 
                                    bootstrapPlugin, 
                                    timelinePlugin,
                                    listPlugin,
                                    resourceCommonPlugin,
                                    luxonPlugin,
                                    momentPlugin,
                                    momentTZPlugin
                                 ],
                pick:[{
                    start:{
                        date: new Date(2016, 9,  16),
                        hour: {
                                HH: "10",
                                mm: "05",
                                ss: "00"
                            },
                    },
                    end:{
                        date: new Date(2016, 9,  16),
                        hour: {
                                HH: "10",
                                mm: "05",
                                ss: "00"
                            },
                    }
                }],
                intervention: {
                    id:                 "",
                    status :            "Intervention à venir",
                    type :              "",
                    isRemote :          true,
                    note :              "",
                    emailReminder:      [],
                    emailRDV:           [],
                    name :              "",
                    planning:           [{
                        user:             {idWeweb: ""},
                        activityType:     "Recherche de fuite",
                        startTimestamp:   1558706400,
                        endTimestamp:     1558710000,
                        isMain:           true,
                        isEstimated:      true,
                        addressStr:       ''
                    }]
                },
                inquiry: {},
            };
        },
        methods:{
            changeHandler(i){
                var fin = this.pick[i].end.date;
                fin.setHours(parseInt(this.pick[i].end.hour.HH), parseInt(this.pick[i].end.hour.mm, 0, 0));

                var debut = this.pick[i].start.date;
                debut.setHours(parseInt(this.pick[i].start.hour.HH), parseInt(this.pick[i].start.hour.mm, 0, 0));

                this.getPlanning((debut / 1000 |0)+1, (fin/1000 |0)-1);
            },
            emailReminderNbInc(){
                this.emailReminderNb = this.emailReminderNb +1;
            },
            emailRDVNbInc(){
                this.emailRDVNb = this.emailRDVNb +1;
                console.log(this.intervention.emailRDV);
            },
            inChargeNbInc(){
                this.inChargeNb = this.inChargeNb +1;
                this.intervention.planning.push({
                    user:             {idWeweb: ''},
                    activityType:     this.intervention.type,
                    startTimestamp:   this.intervention.planning[0].startTimestamp,
                    endTimestamp:     this.intervention.planning[0].endTimestamp,
                    isMain:           false,
                    isEstimated:      true,
                    addressStr:       ""
                })
                this.pick.push({
                    start:{
                        date: this.pick[0].start.date,
                        hour: this.pick[0].start.hour,
                    },
                    end:{
                        date: this.pick[0].end.date,
                        hour: this.pick[0].end.hour,
                    }
                });
                this.planningTitle = "Sélectionnez l'horaire de l'aide supplémentaire : ";
                this.isPlanning = true;
            },
            openModal(){
                this.$modal.show('validationModal');
            },
            closeModal(){
                this.$modal.hide('validationModal');
            },
            okButton(){
                if(this.validationPhrase === "La nouvelle intervention a été correctement enregistré"){
                    this.goToInterventionPage(this.intervention.id);
                }
                else{
                    this.$modal.hide('validationModal');
                }
            },
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },
            async uploadIntervention(){

                var isAllTechFilled = true;

                for(var i=0; i<this.intervention.planning.length; i++){

                    var fin = this.pick[i].end.date;
                    fin.setHours(parseInt(this.pick[i].end.hour.HH), parseInt(this.pick[i].end.hour.mm, 0, 0));

                    var debut = this.pick[i].start.date;
                    debut.setHours(parseInt(this.pick[i].start.hour.HH), parseInt(this.pick[i].start.hour.mm, 0, 0));

                    this.intervention.planning[i].startTimestamp = debut/1000 | 0;
                    this.intervention.planning[i].endTimestamp = fin/1000 | 0;
                    this.intervention.planning[i].activityType = this.intervention.type;
                    if(this.intervention.planning[i].user.idWeweb === ""){
                        isAllTechFilled = false;
                    }
                    this.intervention.planning[i].addressStr = this.addressStr;
                    this.intervention.planning[i].type = this.intervention.type;
                    
                }

                if(this.intervention.type !== "" && isAllTechFilled){

                    var response = await axios.post('https://so.gaviota.fr/api/building/inquiry/intervention/'+this.inquiry.name, {intervention: this.intervention});

                    if(response){
                        this.intervention.id = response.data.intervention._id
                        this.validationPhrase =  "La nouvelle intervention a été correctement enregistré",
                        this.imgValidation = "/assets/right.png",
                        this.openModal();                        
                    }
                    else{
                        this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                        this.imgValidation = "/assets/wrong.png",
                        this.openModal();
                    }
                }
                else{
                    this.validationPhrase =  "Veuillez remplir les champs obligatoires * ",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModal();
                }
            },
            goToInterventionPage(name){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                
                this.$router.replace({ name: "interventionadmin", query: {name: name}  });
            },
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            refresh(){
                location.reload();
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },
            getCookies: function() {
                this.$cookie.set('currentAriane', "Bien n° " +this.$route.query.name);
                this.filAriane = this.$cookie.get('currentAriane');
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau") || !this.$route.query.name){
                    this.$router.replace({ name: "login" });
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                    this.getUserDataForEmail();
                }
            },
            slotDuration(){
                if(this.activeEnd - this.activeStart === 604800 || this.activeEnd - this.activeStart ===  432000){
                    return '03:00:00';
                }
                else{
                    return '00:30:00';
                }
            },
            handleDateClick(data){
                console.log(data.dateStr)
                console.log(data.resource.id)
            },
            eventClick(data){
                console.log(data.event.title)
            },
            datesRender(info){
                this.activeStart = (new Date(info.view.activeStart) /1000 | 0);
                this.activeEnd = (new Date(info.view.activeEnd) /1000 | 0);
                this.getCalendar(this.activeStart, this.activeEnd);
            },
            pickRDV(data){
                console.log("selecting EVENT :");
                console.log(data.start /1000 | 0);
                console.log(data.end /1000 | 0);
                console.log(data.resource.id);

                this.intervention.planning[this.intervention.planning.length-1].startTimestamp = (data.start /1000 | 0);
                this.intervention.planning[this.intervention.planning.length-1].endTimestamp = (data.end /1000 | 0);
                this.intervention.planning[this.intervention.planning.length-1].user.idWeweb = data.resource.id;

                this.pick[this.intervention.planning.length-1].start.date = new Date(this.intervention.planning[this.intervention.planning.length-1].startTimestamp*1000)
                this.pick[this.intervention.planning.length-1].end.date = new Date(this.intervention.planning[this.intervention.planning.length-1].endTimestamp*1000)
                this.pick[this.intervention.planning.length-1].start.hour = {
                                            HH:("0" + new Date(this.intervention.planning[this.intervention.planning.length-1].startTimestamp*1000).getHours()).substr(-2),
                                            mm:("0" + new Date(this.intervention.planning[this.intervention.planning.length-1].startTimestamp*1000).getMinutes()).substr(-2),
                                            ss:"00"
                                        };
                                            
                this.pick[this.intervention.planning.length-1].end.hour = {
                                            HH:("0" + new Date(this.intervention.planning[this.intervention.planning.length-1].endTimestamp*1000).getHours()).substr(-2),
                                            mm:("0" + new Date(this.intervention.planning[this.intervention.planning.length-1].endTimestamp*1000).getMinutes()).substr(-2),
                                            ss:"00"
                                        };
                this.getPlanning(this.intervention.planning[this.intervention.planning.length-1].startTimestamp +1, this.intervention.planning[this.intervention.planning.length-1].endTimestamp-1);   
                this.isPlanning = false;
            },
            async getUserName(){
                    
                var response = await axios.get('https://so.gaviota.fr/api/userdata/admin/all');
                if(response.data.users){
                    this.users = response.data.users;
                    for(var o=0; o<this.users.length; o++){
                        if(this.users[o].role !== "client"){
                            this.calResources.push({
                                                    id:this.users[o].idWeweb,
                                                    title:this.users[o].address.firstName + " " + this.users[o].address.lastName,
                                                    eventColor:this.color[o]
                                                    }) 
                        }
                    }
                    this.getPlanning(this.intervention.planning[0].startTimestamp+1, this.intervention.planning[0].endTimestamp-1);         
                }
            },
            async getCalendar(start, end){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/planning/'+start+"/"+end);
                if(response.data.plannings){
                    this.calEvents = [];
                    for(var o=0; o<response.data.plannings.length; o++){
                        this.calEvents.push({
                                                resourceId:response.data.plannings[o].user.idWeweb,
                                                title:response.data.plannings[o].activityType,
                                                start:new Date(response.data.plannings[o].startTimestamp*1000),
                                                end:new Date(response.data.plannings[o].endTimestamp*1000)
                                            });
                    }         
                }                            
            },
            async getPlanning(start, end){
                var response = await axios.get('https://so.gaviota.fr/api/building/planning/'+start+"/"+end);
                if(response.data.plannings){
                    this.plannings = [];
                    this.plannings = response.data.plannings;

                    var alreadyBusy = false;
                    this.inchargeToSelect = [];

                    for(var i=0; i<this.inchargeToSelectAll.length; i++){
                        alreadyBusy = false;
                        for(var j=0; j<this.plannings.length; j++){
                            if(this.plannings[j].user.idWeweb === this.inchargeToSelectAll[i].idWeweb){
                                alreadyBusy = true;
                            }
                        }
                        if(!alreadyBusy){
                            this.inchargeToSelect.push(this.inchargeToSelectAll[i])
                        }
                    }
                }
            },
            async getUserDataForEmail(){
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/user/'+this.$route.query.name);
                if(response.data.users){
                    for(var i=0; i<response.data.users.length; i++){
                        if(response.data.users[i].emailAddress && response.data.users[i].emailAddress  !== ""){
                           this.UserDataForEmail.push(response.data.users[i]);
                        }
                        if(response.data.users[i].addressStr && response.data.users[i].addressStr  !== ""){
                            this.addressStr = response.data.users[i].addressStr;
                        }
                    }
                    this.getInquiry();
                }
            },
            async getInquiry(){
                var nameInq = this.$route.query.name.split('/').join('%2F');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq);
                
                if(response.data.inquiry){
                    this.inquiry = response.data.inquiry;
                    this.intervention.name = "intervention n°"+(this.inquiry.intervention.length +1);
                    
                    if(this.$route.query.startTimestamp && this.$route.query.endTimestamp){
                        this.intervention.planning[0].startTimestamp = parseInt(this.$route.query.startTimestamp);
                        this.intervention.planning[0].endTimestamp = parseInt(this.$route.query.endTimestamp);

                        var isNextId = false;
                        var nextId = 1;
                        var nextIdName = "id"+nextId;
    
                        if(this.$route.query.id1){
                            this.intervention.planning[0].user.idWeweb = this.$route.query.id1;
                            isNextId = true;
                            nextId++;
                            nextIdName = "id"+nextId;
                        }
                        while(isNextId){
                            if(this.$route.query[nextIdName]){
                                this.intervention.planning.push({
                                    user:             {idWeweb: this.$route.query[nextIdName]},
                                    activityType:     this.intervention.type,
                                    startTimestamp:   this.intervention.planning[0].startTimestamp,
                                    endTimestamp:     this.intervention.planning[0].endTimestamp,
                                    isMain:           false,
                                    isEstimated:      true
                                })
                                this.inChargeNb = this.inChargeNb +1;
                                isNextId = true;
                                nextId++;
                                nextIdName = "id"+nextId;
                            }
                            else{
                                isNextId = false;
                            }
                        }
                    }
                    else{
                        var dateNow = new Date() / 1000 | 0;
                        this.intervention.planning[0].startTimestamp = (dateNow - (dateNow%1800));
                        this.intervention.planning[0].endTimestamp = 1800 + (dateNow - (dateNow%1800));
                    }

                    this.pick[0].start.date = new Date(this.intervention.planning[0].startTimestamp*1000)
                    this.pick[0].end.date = new Date(this.intervention.planning[0].endTimestamp*1000)

                    this.pick[0].start.hour = {
                                                HH:("0" + new Date(this.intervention.planning[0].startTimestamp*1000).getHours()).substr(-2),
                                                mm:("0" + new Date(this.intervention.planning[0].startTimestamp*1000).getMinutes()).substr(-2),
                                                ss:"00"
                                            };
                                                
                    this.pick[0].end.hour = {
                                                HH:("0" + new Date(this.intervention.planning[0].endTimestamp*1000).getHours()).substr(-2),
                                                mm:("0" + new Date(this.intervention.planning[0].endTimestamp*1000).getMinutes()).substr(-2),
                                                ss:"00"
                                            };

                    this.getUserData();
                }
                else{
                    this.logout();
                }
            },
            async getUserData(){
                var response = await axios.get('https://so.gaviota.fr/api/userdata/admin/all');
                if(response.data.users){
                    for(var i=0; i<response.data.users.length; i++){
                        if(response.data.users[i].role !== "client"){
                            this.inchargeToSelect.push(response.data.users[i]);
                            this.inchargeToSelectAll.push(response.data.users[i]);
                        }
                    }
                    this.getUserName();
                }
            },
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #newintervention {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    h2{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding:15px;
        font-size: 24px;
        font-weight: 600;
        display: block;
        border-bottom: 2px solid #1ce83e6e;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:2;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    .btn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        display: inline-block;
        width: 100px;
    }
    .left{
        float:left;
    }
    .right{
        float:right;
    }
    .imgCard{
        width:100%;
        height: 200px;
        object-fit: cover;
        cursor: pointer;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    #circleRed {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 60px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        background-color: #F0F0F0;
        border-bottom: 2px solid;
        border-color:#1ce83e28;
        padding:10px;
        margin:2px;
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 17px;
    }
    @media screen and (max-width: 768px) {
        .spanCard {
              font-size: 14px;
            }
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .notifList{
        margin-bottom: 10px;
    }
    .container{
        padding: 20px;
        font-size: 17px;
        font-family: 'BenchNine', sans-serif;
        -webkit-column-count: 2; /* Old Chrome, Safari and Opera */
        -moz-column-count: 2; /* Old Firefox */
        column-count: 2;
    }
    .containerSingle{
        padding: 20px;
        font-size: 17px;
        font-family: 'BenchNine', sans-serif;
    }
    .btnContainer{
        padding:20px;
        background-color: #FFF;
        margin-bottom: 20px;
        text-align: center;
    }
    hr{
        margin-bottom: 0px;
        border-color: rgba(240, 240, 240, 0.3);
        color: rgba(240, 240, 240, 0.3);
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }		
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:999;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    .textline{
        padding:5px;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .editBtn{
        width:30px;
        height: 30px;
        position:absolute;
        bottom:20px;
        right:20px;
        cursor:pointer;
    }
    .inputTxt{
        width:calc(100% - (100px + 50px));
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
        background-color: #F7F7F7;
        border: 1px solid #bbb;
        padding-left:5px;
        margin-left:5px;
        display: inline-block;
    }
    .fifty{
        width:calc(50% - (25px + 50px));
        display: inline-block;
    }
    .inlineBlock{
        display: inline-block;
    }
    .btnNewBtn{
        width:25px;
        height: 25px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:black;
        cursor: pointer;
        background-color: #1ce83e;
        display:inline-block;
        margin:10px;
    }
    .area{
        resize: none;
        width: calc(100% - (100px + 50px));
    }
    .select{
        width: calc(100% - (100px + 40px));
        margin-bottom:10px;
    }
    h3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        margin: 0px 0px 0px 15px;
    }
    .textLen{
        width:120px;
        display: inline-block;
    }
    .radioBtn{
        margin-left:10px;
        margin-right:5px;
    }
    input[type='radio']:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #d1d3d1;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background: radial-gradient(#1ce83e, #ddd);
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    .blockBtn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: block;
    }
    .modalDiv{
        margin:30px;
        text-align: center;
    }
    .modalTxt{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .txtDiv{
        margin-bottom: 15px; 
    }
    .docBtn3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
    }
    .high{
        height: 200px;
        vertical-align:top;
    }
    .wrapperDate{
        display: inline-block;
        width:calc(100% - (100px + 40px));
    }
    .allselects{
        display:inline-block;
    }
    .calendar{
        font-family: 'BenchNine', sans-serif;
        font-size: 14px;
        margin: 40px auto;
    }
</style>

<style lang="scss" module>
    html>body>div>div>div>div>div>div>div>div>input{
                    width:100% !important;
                    font-family: 'BenchNine', sans-serif;
                    font-stretch: ultra-condensed;
                    font-size: 18px;
                    background-color: #F7F7F7;
                    border: 1px solid #bbb;
                    padding-left:5px;
                    margin-left:5px;
                    display: inline-block;
    }
    html>body>div>div>div>div>div>div>span>input{
                    width:100% !important;
                    font-family: 'BenchNine', sans-serif;
                    font-stretch: ultra-condensed;
                    font-size: 18px;
                    background-color: #F7F7F7;
                    border: 1px solid #bbb;
                    padding-left:5px;
                    margin-left:5px;
                    display: inline-block;
    }
    .wrapperDate{
        display: inline-block;
        width:calc(100% - (100px + 40px));
    }
</style>